import { useEffect, useLayoutEffect, useState } from 'react';
import cn from 'classnames';

import AdvertisementUtil from '@utils/AdvertisementUtil';
import { ADVERTISEMENT_DEVICE, ADVERTISEMENT_TYPE } from '@constants/enums';
import { useIsMobile } from './useIsMobile';

import styles from '../components/layout/Advertisement/Advertisement.module.scss';
import { render } from 'react-dom';
import { useRouter } from 'next/router';

export const useAdvertisement = (
  advertisementType: ADVERTISEMENT_TYPE,
  advertisementDevice: ADVERTISEMENT_DEVICE,
  selector: string,
  nthChild = 1,
  className?: string,
) => {
  const isMobile = useIsMobile();
  const { asPath } = useRouter();
  const [delayedPath, setDelayedPath] = useState('');

  useEffect(() => {
    if (asPath === delayedPath) return;

    const timeout = setTimeout(() => setDelayedPath(asPath), 10);

    return () => clearTimeout(timeout);
  }, [asPath]);

  useEffect(() => {
    try {
      if (window.adsbygoogle?.loaded && asPath === delayedPath) {
        document.querySelectorAll('ins').forEach(() => window.adsbygoogle?.push({}));
      }
    } catch (_) {}
  }, [asPath, delayedPath]);

  switch (advertisementDevice) {
    case ADVERTISEMENT_DEVICE.DESKTOP:
      if (isMobile) {
        return;
      }
      break;
    case ADVERTISEMENT_DEVICE.MOBILE:
      if (!isMobile) {
        return;
      }
      break;
  }

  const advertisement = AdvertisementUtil.selectAdvertisement(advertisementType);

  useLayoutEffect(() => {
    const element = document.querySelectorAll(selector);

    if (element === null) {
      return;
    }
    if (element.length < nthChild) {
      return;
    }

    const advertisementElement = document.createElement('div');
    advertisementElement.className = cn(styles.Advertisement, className);
    render(advertisement, advertisementElement);
    element[nthChild - 1].parentElement?.insertBefore(advertisementElement, element[nthChild - 1]);

    if (window.adsbygoogle?.loaded) {
      try {
        window.adsbygoogle?.push({});
      } catch {}
    }

    return () => advertisementElement.remove();
  }, [asPath]);
};
